import { DataType } from '@debbie/common/dist/query/types.js'
import * as db from '@debbie/common/dist/query/db.js'
import React from 'react'
import {
  BooleanDisplay,
  CaseIdDisplay,
  CaseStatusDisplay,
  CurrencyDisplay,
  CaseVoucherSourceDisplay,
  CaseVoucherStateDisplay,
  DateDisplay,
  EnumDisplay,
  FloatDisplay,
  IntDisplay,
  MoneyDisplay,
  StringDisplay,
  UnknownDisplay,
  JSONDisplay,
  UUIDDisplay,
} from './Displays.js'
import PerformedBy from '@debbie/iris/dist/components/performed-by/PerformedBy.js'
import { PerformedBy as PerformedByT } from '@debbie/common/dist/performed-by/index.js'
import { Property } from '@debbie/common/dist/query/index.js'

export const CustomComponent: {
  [K in Property<typeof db.schema>]?: React.ComponentType<{ value: any }>
} = {
  //'cases.id': CaseIdDisplay,
  //'cases.status': CaseStatusDisplay,
  'caseVouchers.source': CaseVoucherSourceDisplay,
  'caseVouchers.state': CaseVoucherStateDisplay,
  'caseVouchers.currency': CurrencyDisplay,
  'views.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'views.updatedBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'cases.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'payouts.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'updates.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'billings.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'endReasons.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'properties.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'cosmoEvents.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'caseVouchers.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'interactions.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'billingModels.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'propertyTypes.createdBy': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
  'paymentMethods.createdAt': (props: { value: PerformedByT }) => (
    <PerformedBy performedBy={props.value} />
  ),
}

export const DisplayComponent: {
  [K in DataType['type']]: React.ComponentType<{ value: any }>
} = {
  boolean: BooleanDisplay,
  date: DateDisplay,
  enum: EnumDisplay,
  float: FloatDisplay,
  int: IntDisplay,
  money: MoneyDisplay,
  string: StringDisplay,
  unknown: UnknownDisplay,
  uuid: UUIDDisplay,
  json: JSONDisplay,
}
